import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import Navbar from '../../components/Navbar'
import Sidebar from '../../components/Sidebar'
import PainelOperacional from './PainelOperacional'
import PainelExpedicao from './PainelExpedicao'
import Relatorios from './Relatorios'
import './dashoperacional.css'

// Dashboard com renderização das páginas do menu lateral
const DashboardOperacional = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [sidebarVisible, setSidebarVisible] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [activeKey, setActiveKey] = useState('operacional')

  // Detecta a página atual baseado na URL
  useEffect(() => {
    if (location.pathname === '/painel-operacional') {
      setActiveKey('operacional')
    } else if (location.pathname === '/painel-expedicao') {
      setActiveKey('expedicao')
    } else if (location.pathname === '/relatorios') {
      setActiveKey('relatorios')
    }
  }, [location.pathname])

  const handleMobileMenuClick = () => {
    setSidebarVisible((prev) => !prev)
  }

  useEffect(() => {
    const handleSidebarToggle = (event) => {
      setSidebarCollapsed(event.detail.collapsed)
    }

    window.addEventListener('sidebarToggle', handleSidebarToggle)
    return () => window.removeEventListener('sidebarToggle', handleSidebarToggle)
  }, [])

  const renderContent = () => {
    switch (activeKey) {
      case 'operacional':
        return <PainelOperacional embedded />
      case 'expedicao':
        return <PainelExpedicao embedded />
      case 'relatorios':
        return <Relatorios embedded />
      default:
        return <PainelOperacional embedded />
    }
  }

  return (
    <div className="painel-operacional">
      <Navbar onMenuClick={handleMobileMenuClick} />
      {/* Sidebar Desktop/Mobile */}
      <Sidebar
        visible={sidebarVisible}
        onClose={() => setSidebarVisible(false)}
        onMenuClick={({ key }) => {
          if (key === 'operacional') navigate('/painel-operacional')
          if (key === 'expedicao') navigate('/painel-expedicao')
          if (key === 'relatorios') navigate('/relatorios')
          setSidebarVisible(false) // Fecha sidebar mobile após navegação
        }}
      />

      {/* Área de conteúdo controlada pela sidebar */}
      <div
        className={`painel-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}
      >
        {renderContent()}
      </div>
    </div>
  )
}

export default DashboardOperacional